import AttachDetailsComponent from './AttachDetailsComponent';

export default AttachDetailsComponent;
